import React from 'react';

// ui part
import PictureSide from './login/PictureSide';
import ResetForm from './login/ResetForm';

const ResetUI = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100vh', overflow: "hidden" }}>
      <div className="bg-gray-600 hidden lg:block w-full md:w-1/2 xl:w-2/3 h-screen">
        <PictureSide />
      </div>
      <div className="bg-white w-full md:max-w-md lg:max-w-full md:mx-auto md:mx-0 md:w-1/2 xl:w-1/3 h-screen px-6 lg:px-16 xl:px-12
        flex items-center justify-center">
        <ResetForm />
      </div>
    </div>
  );
}

export default ResetUI;
